export default "__VITE_ASSET__C8rK94A7__"